<template>
  <button
    :type="type"
    :id="id"
    :disabled="isDisabled"
    class="flex items-center border border-transparent relative max-w-full"
    :class="[buttonClass, hoverIcon]"
    @click="$emit('click')"
  >
    <svg
      v-if="label === 'message'"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_339_6725)">
        <path
          d="M16.0009 7.5C16.0009 11.0906 12.4197 14 8.00093 14C6.84155 14 5.74155 13.8 4.7478 13.4406C4.37593 13.7125 3.76968 14.0844 3.05093 14.3969C2.30093 14.7219 1.3978 15 0.500927 15C0.297802 15 0.116552 14.8781 0.0384267 14.6906C-0.0396983 14.5031 0.00405172 14.2906 0.144677 14.1469L0.154052 14.1375C0.163427 14.1281 0.175927 14.1156 0.194677 14.0938C0.229052 14.0562 0.282177 13.9969 0.347802 13.9156C0.475927 13.7594 0.647802 13.5281 0.822802 13.2406C1.1353 12.7219 1.43218 12.0406 1.49155 11.275C0.554052 10.2125 0.000926722 8.90938 0.000926722 7.5C0.000926722 3.90937 3.58218 1 8.00093 1C12.4197 1 16.0009 3.90937 16.0009 7.5Z"
          fill="#717986"
        />
      </g>
      <defs>
        <clipPath id="clip0_339_6725">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="label === 'delete black'"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="trash-2">
        <path
          id="Vector"
          d="M2.25 5H3.75H15.75"
          stroke="#010A11"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M14.25 5V15.5C14.25 15.8978 14.092 16.2794 13.8107 16.5607C13.5294 16.842 13.1478 17 12.75 17H5.25C4.85218 17 4.47064 16.842 4.18934 16.5607C3.90804 16.2794 3.75 15.8978 3.75 15.5V5M6 5V3.5C6 3.10218 6.15804 2.72064 6.43934 2.43934C6.72064 2.15804 7.10218 2 7.5 2H10.5C10.8978 2 11.2794 2.15804 11.5607 2.43934C11.842 2.72064 12 3.10218 12 3.5V5"
          stroke="#010A11"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_3"
          d="M7.5 8.75V13.25"
          stroke="#010A11"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_4"
          d="M10.5 8.75V13.25"
          stroke="#010A11"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      v-else-if="label === 'complete white'"
    >
      <path
        d="M13.0547 4.24023L6.16091 11.1341L3.02734 8.00051"
        stroke="white"
        stroke-width="1.67123"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      v-else-if="label === 'delete gray'"
    >
      <path
        d="M1 1H15C15.5531 1 16 1.44687 16 2V3C16 3.55312 15.5531 4 15 4H1C0.446875 4 0 3.55312 0 3V2C0 1.44687 0.446875 1 1 1ZM1 5H15V13C15 14.1031 14.1031 15 13 15H3C1.89688 15 1 14.1031 1 13V5ZM5 7.5C5 7.775 5.225 8 5.5 8H10.5C10.775 8 11 7.775 11 7.5C11 7.225 10.775 7 10.5 7H5.5C5.225 7 5 7.225 5 7.5Z"
        fill="#717986"
      />
    </svg>
    <svg  v-else-if="label === 'add light-gray'" xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 24 25" fill="none">
  <path d="M12 5.5V19.5" stroke="#717986" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5 12.5H19" stroke="#717986" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    <!-- <svg
     
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M12 5.5V19.5"
        stroke="#717986"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 12.5H19"
        stroke="#717986"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg> -->
    <svg
      v-else-if="label === 'add white'"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 2V18"
        stroke="white"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 10H18"
        stroke="white"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="label === 'add gray'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2V18"
        stroke="#010A11"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 10H18"
        stroke="#010A11"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="label === 'add black'"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4.25V14.75"
        stroke="#010A11"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 9.5H14.25"
        stroke="#010A11"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="label === 'reset'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1037_14521)">
        <path
          d="M6.66667 12H9.33333V10.6667H6.66667V12ZM2 4V5.33333H14V4H2ZM4 8.66667H12V7.33333H4V8.66667Z"
          fill="#717986"
        />
      </g>
      <defs>
        <clipPath id="clip0_1037_14521">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      v-else-if="label === 'reopen'"
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="black"
    >
      <path
        d="M5.59223 5.51193L5.60337 5.52307L5.61458 5.512C8.386 2.77538 12.85 2.78489 15.6056 5.54363L15.6056 5.54364C18.3738 8.31188 18.3738 12.798 15.6056 15.5663C12.8373 18.3345 8.35119 18.3345 5.58295 15.5663C5.19279 15.1761 5.19279 14.5425 5.58295 14.1523C5.9731 13.7622 6.60674 13.7622 6.99689 14.1523C8.98483 16.1403 12.2069 16.1403 14.1948 14.1523C16.1827 12.1644 16.1827 8.94234 14.1948 6.95441C12.2164 4.97602 9.01981 4.96648 7.0287 6.9226L7.0173 6.9338L7.02859 6.94511L8.33178 8.25147L8.33179 8.25149C8.546 8.4657 8.60814 8.78547 8.49322 9.065C8.37838 9.34433 8.10521 9.52445 7.80397 9.52445H4.01488H3.74536C3.33241 9.52445 3.00023 9.19227 3.00023 8.77931V4.7207C3.00023 4.41947 3.18034 4.14629 3.45968 4.03145C3.7392 3.91654 4.05898 3.97867 4.27319 4.19288L5.59223 5.51193Z"
        fill="black"
        stroke="black"
        stroke-width="0.0317079"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      v-else-if="label === 'edit'"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_715_57720)">
        <path
          d="M11.0237 2.35903C11.1883 2.19443 11.3837 2.06386 11.5988 1.97478C11.8139 1.88569 12.0444 1.83984 12.2772 1.83984C12.5099 1.83984 12.7404 1.88569 12.9555 1.97478C13.1706 2.06386 13.366 2.19443 13.5306 2.35903C13.6952 2.52363 13.8258 2.71904 13.9148 2.93411C14.0039 3.14917 14.0498 3.37967 14.0498 3.61245C14.0498 3.84524 14.0039 4.07574 13.9148 4.2908C13.8258 4.50587 13.6952 4.70128 13.5306 4.86588L5.06996 13.3265L1.62305 14.2666L2.56312 10.8196L11.0237 2.35903Z"
          stroke="#010A11"
          stroke-width="1.25342"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_715_57720">
          <rect
            width="15.0411"
            height="15.0411"
            fill="white"
            transform="translate(0.369141 0.478516)"
          />
        </clipPath>
      </defs>
    </svg>
    <span v-if="buttonText" :class="textClass" class="pl-2">{{
      buttonText
    }}</span>
  </button>
</template>

<script>
export default {
  props: {
    type: String,
    id: String,
    isDisabled: Boolean,
    buttonClass: String,
    textClass: String,
    label: String,
    buttonText: String,
  },

  computed: {
    hoverIcon() {
      return this.buttonText || this.buttonClass === "customAdd"
        ? "icon-background"
        : "";
    },
  },
};
</script>
<style scoped>
.customMessage {
  position: absolute;
  right: 31px;
  top: 0;
}
.customDelete,
.customAddCompany {
  position: absolute;
  right: 0;
  top: 0;
}
.customAddCompanyMarketplace {
  position: absolute;
  right: 67px;
  top: -2px;
}
.customAddCompanyMarketplaceAdmin{
  position: absolute;
  right: 0;
  top: -2px;
}
.customAdd:active {
  outline: none;
}
.customAdd {
  border-radius: 38px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
  background: var(--colorBgContainer, #fff);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
  height: 32px;
}
.customAdd:hover{
background-color: #FFDA69;
border: 1px solid #FFDA69;
}
.customAdd:hover span{
  color: #010a11;
  font-weight: 400;
}
.customAddWhite {
  background-color: #070823;
  color: white !important;
  font-size: 16px;
  font-weight: 500;
}
.customEdit{
  color: #010A11;
text-align: center;
font-family: Outfit;
font-size: 11.699px;
font-style: normal;
font-weight: 500;
line-height: 16.712px;
padding: 8.356px 20.055px 8.356px 13.37px;
letter-spacing: 0.084px;
}
.customText {
  color: #717986;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 8px;
}
.customOnlyText {
  margin-left: 0px;
  padding-left: 0px;
}
.icon-background:hover {
  background-color: #FFDA69;
  border: 1px solid #FFDA69;
}
</style>
